import { Component, computed, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService } from '@eforall/dashboard';
import { DialogMode } from '@interfaces';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { GoalEditorDialogData } from '../goal-dialog-data';
import { GoalEditorDialog } from '../goal-editor/goal-editor.dialog';
import { GoalCommentsPart } from './comments/comments.part';
import { GoalDetailsPart } from './details/details.part';
import { GoalDetailsDialogDataService } from './goal-details-dialog-data.service';


@Component({
	selector: 'goal-details-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		TabStripModule,
		GoalDetailsPart,
		GoalCommentsPart,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './goal-details.dialog.html'
})

export class GoalDetailsDialog implements OnInit {

	public dialogRef = inject(MatDialogRef<GoalDetailsDialog>);
	public dialogContext: DialogContext<{ accGoalId: number }> = inject(MAT_DIALOG_DATA);

	private readonly dialogService = inject(DialogService);
	private dialogDataService = inject(GoalDetailsDialogDataService);

	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data) {
			await this.dialogDataService.loadDetails(data.accGoalId);
		}
	}

	public header = computed(() => this.dialogDataService.goalDetails()?.summary ?? '');

	public actions = computed<DialogAction[]>(() => {
		const actions: DialogAction[] = [];
		const goalDetails = this.dialogDataService.goalDetails();
		if (!goalDetails) return actions;

		const editButton: DialogAction = {
			id: 'edit',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Edit'),
			callback: async () => {
				const data = this.dialogContext.data;
				if (data) {
					const editorDialogData: GoalEditorDialogData = {
						mode: DialogMode.EDIT,
						accGoalId: data.accGoalId,
						ventureName: goalDetails.ventureName,
					};
					await this.dialogService.showCustom(GoalEditorDialog, { data: editorDialogData }, 650, 650);
					await this.dialogDataService.loadDetails(data.accGoalId);
				}
			},
			linkType: 'callback',
			willCloseDialog: false,
		};

		if (this.dialogDataService.canEdit()) actions.push(editButton);

		actions.push(
			{
				id: 'cancel',
				cssClass: signal(undefined),
				enabled: signal(true),
				visible: signal(true),
				text: signal('Cancel'),
				linkType: "no-action",
				willCloseDialog: true,
			}
		);

		return actions;
	});


}